export default __webpack_public_path__ + "static/environment_grow_box_d-157b3603a5020bf1d6754c7a730f9666.png";